<script>
import Live from './subpages/Live'
import Staging from './subpages/Staging'
import Archived from './subpages/Archived'
export default {
    components: 
    {
        [Live.name]: Live,
        [Staging.name]: Staging,
        [Archived.name]: Archived,
    },
    name: 'landing-pages',
    data()
    {
        return {
            menu: [
                {
                    name:'Live',
                    slug:'live',
                },
                {
                    name:'Staging',
                    slug:'staging',
                },
                {
                    name:'Archived',
                    slug:'archived',
                },
            ],
        }
    },
}
</script>

<template lang="html">
    <div class="offers-page">
        <panel-wrapper :menu="menu" routerName="landing-pages-subpages">
            <div slot="panel-wrapper-content">
                <div v-if="$route.params.slug == 'live'">
                    <live-landing-pages></live-landing-pages>
                </div>
                <div v-if="$route.params.slug == 'staging'">
                    <staging-landing-pages></staging-landing-pages>
                </div>
                <div v-if="$route.params.slug == 'archived'">
                    <archived-landing-pages></archived-landing-pages>
                </div>
            </div>
        </panel-wrapper>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/landingpages/LandingPages.vue